import { Flex } from 'antd';
import styles from './loader.module.scss';

export default function Loader() {
  return (
    <Flex align="center" className={styles.loaderWrapper}>
      <span className={styles.loader}></span>
    </Flex>
  );
}
